import { Flex } from '@grupoboticario/flora-react';
import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.background};
  @media (max-width: 767px) {
    padding: 0px 0px 72px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 136px);
  height: fit-content;
  padding: 0 30px 0px 60px;
`;

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 136px);
  height: fit-content;
  padding: 0 30px;
`;

export const ButtonWrapper = styled.div`
  margin: 0 auto;
  button.sair,
  button.enviar {
    display: inline-block;
    margin: 10px;
    & svg {
      margin: 0 0 0 5px;
      vertical-align: middle;
    }
    & svg path {
      fill: #fff;
    }
    & svg.disabled path {
      fill: #878787;
    }
  }
`;

export const Title = styled.div`
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  color: #000;
  width: 100%;
  margin: 30px 0 0px;
`;

export const Card = styled.div`
  flex: 1;
  width: 195px;

  &.card-text {
    padding: 30px 24px;
    font-family: ${({ theme }) => theme.fonts.secondary};
    border-right: 1px solid ${({ theme }) => theme.colors.line};
    span {
      display: block;
      color: ${({ theme }) => theme.colors.error};
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: 18px;
      letter-spacing: 0em;
      text-align: left;
      height: 40px;
      margin-bottom: 13px;
    }
    p,
    li {
      font-size: 12px;
      font-weight: 500;
      line-height: 18px;
    }
    ul li {
      list-style: inside disc;
    }
  }

  &.card-upload {
    padding: 16px 12px;
    font-family: ${({ theme }) => theme.fonts.secondary};
    .card-upload-text {
      text-align: center;
      p {
        font-size: 10px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px;
        letter-spacing: 0em;
      }
      span {
        font-size: 15px;
        font-style: normal;
        font-weight: 700;
        line-height: 18px;
        letter-spacing: 0em;
        margin: auto;
      }
    }

  @media (max-width: 570px) {
    width: 100%;
    &.card-text {
      padding: 24px 24px;
      border-right: 0;
      border-bottom: 1px solid ${({ theme }) => theme.colors.line};
      span {
        height: auto;
      }
    }
  }
`;

export const CardDocumentContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 6px;
  margin-bottom: 12px;
  flex-wrap: wrap;
  @media (max-width: 570px) {
    flex-direction: column;
  }
`;

export const CardContainer = styled.div`
  width: fit-content;
  border-radius: 4px;

  background: ${({ theme }) => theme.colors.shape};
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.32);

  font-size: 11px;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: left;
  margin-bottom: 30px;
  display: flex;
  flex-direction: row;

  @media (max-width: 570px) {
    width: 100%;

    flex-direction: column;
  }
`;

export const Label = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 25px;
  letter-spacing: 0em;
  text-align: left;
  margin-bottom: 17px;
  margin-top: 8px;
  color: #636363;
`;

export const ModalText = styled.div`
  max-width: 270px;
  margin: auto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: center;
  color: ${({ theme }) => theme.colors.main};
  padding: 0 24px;
  & span {
    display: block;
    font-size: 16px;
    font-weight: 700;
    margin: 17px 0;
  }
  svg {
    display: block;
    margin: 0px auto 15px;
    box-sizing: content-box;
    width: 55px;
    height: 55px;
  }
`;

export const ModalIcon = styled.div`
  display: flex;
  justify-content: center;
`;

export const SidebarWrapper = styled(Flex)`
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.shape};

  padding: 22px;

  min-height: 340px;
  width: 350px;
  flex-direction: column;
`;

export const Sidebar = styled.div`
  padding-bottom: 16px;

  ul {
    list-style: none;
    padding: 0;
  }
  li {
    padding: 10px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  svg {
    width: 24px;
    height: 24px;
  }
  .content {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px;
  }
`;
